<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<app-loader></app-loader>
<div class="access-popup" [formGroup]="accessCodeForm">
    <div class="access-heading">
        <h4>Access Code </h4>
        <img class="access-code-close" src="../../assets/images/new-close.svg" (click)="close()" alt="Close"/>
    </div>
    <div class="sub-heading">
        <h5>Access code that the driver needs to use at the time of <br />check-in or re-entry.</h5>
        <p>To use the same code for one-time and monthly bookings, enter the same code.</p>
    </div>
    <div class="access-input-outer">
        <div class="access-outer">
            <div class="current-outer">
                <p>Current access code</p>
                <h4>{{ dailyAccessCode || 'System Generated' }}</h4>
            </div>
            <div class="one-time-outer">
                <label for="oneTimeAccessCode">One-time access code</label>
                <input id="oneTimeAccessCode" type="text" formControlName="oneTimeAccessCode" pInputText maxlength="10"
                    placeholder="Enter new access code" (keydown)="preventSpaces($event)" />
                <div
                    *ngIf="accessCodeForm.get('oneTimeAccessCode')?.hasError('required')  && (accessCodeForm.get('oneTimeAccessCode')?.dirty || accessCodeForm.get('oneTimeAccessCode')?.touched)">
                    <div class="validation-error"> This field is required*</div>
                </div>
                <div
                    *ngIf="accessCodeForm.get('oneTimeAccessCode').hasError('minlength') && !accessCodeForm.get('oneTimeAccessCode').hasError('pattern')">
                    <div class="validation-error">Min. 2 digits are required.</div>
                </div>
            </div>

        </div>
        <div class="access-outer">
            <div class="current-outer">
                <p>Current access code</p>
                <h4>{{ monthlyAccessCode || 'System Generated' }}</h4>
            </div>
            <div class="one-time-outer">
                <label for="monthlyAccessCode">Monthly access code</label>
                <input id="monthlyAccessCode" type="text" formControlName="monthlyAccessCode" pInputText maxlength="10"
                    placeholder="Enter new access code" (keydown)="preventSpaces($event)" />
                <div
                    *ngIf="accessCodeForm.get('monthlyAccessCode')?.hasError('required')  && (accessCodeForm.get('monthlyAccessCode')?.dirty || accessCodeForm.get('monthlyAccessCode')?.touched)">
                    <div class="validation-error"> This field is required*</div>
                </div>
                <div
                    *ngIf="accessCodeForm.get('monthlyAccessCode').hasError('minlength') && !accessCodeForm.get('monthlyAccessCode').hasError('pattern')">
                    <div class="validation-error">Min. 2 digits are required.</div>
                </div>
            </div>
        </div>
        <div class="confirm-btn">
            <p-button label="Confirm" (onClick)="save()" />
        </div>
    </div>

</div>